"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function isObject(data) {
    return Object.prototype.toString.call(data) === '[object Object]';
}
var EnvManager = /** @class */ (function () {
    function EnvManager(option) {
        if (option === void 0) { option = {}; }
        this.env = {};
        var buildEnv = process.env;
        var deployEnv = {};
        var devEnv = {};
        if (typeof window !== 'undefined') {
            deployEnv = window[option.key || 'envConfig'] || {};
        }
        if (buildEnv.NODE_ENV === 'development' && isObject(option.developmentEnvs)) {
            devEnv = __assign({}, option.developmentEnvs);
        }
        this.env = Object.freeze(__assign(__assign(__assign({}, buildEnv), deployEnv), devEnv));
    }
    EnvManager.prototype.get = function (key) {
        var isValid = Object.hasOwnProperty.call(this.env, key);
        if (!isValid) {
            throw new Error("\u5F53\u524D\u7684\u73AF\u5883\u53D8\u91CF\u96C6\u5408\u4E2D\u4E0D\u5B58\u5728\u3010" + key + "\u3011\uFF0C\u8BF7\u68C0\u67E5\u53D8\u91CF\u540D\u79F0\u662F\u5426\u6B63\u786E");
        }
        return this.env[key];
    };
    return EnvManager;
}());
exports.default = EnvManager;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUlBLFNBQVMsUUFBUSxDQUFDLElBQVM7SUFDekIsT0FBTyxNQUFNLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssaUJBQWlCLENBQUE7QUFDbkUsQ0FBQztBQU9EO0lBQ0Usb0JBQVksTUFBc0I7UUFBdEIsdUJBQUEsRUFBQSxXQUFzQjtRQW9CekIsUUFBRyxHQUFjLEVBQUUsQ0FBQTtRQW5CMUIsSUFBTSxRQUFRLEdBQVEsT0FBTyxDQUFDLEdBQUcsQ0FBQTtRQUNqQyxJQUFJLFNBQVMsR0FBRyxFQUFFLENBQUE7UUFDbEIsSUFBSSxNQUFNLEdBQUcsRUFBRSxDQUFBO1FBRWYsSUFBSSxPQUFPLE1BQU0sS0FBSyxXQUFXLEVBQUU7WUFDakMsU0FBUyxHQUFJLE1BQWMsQ0FBQyxNQUFNLENBQUMsR0FBRyxJQUFJLFdBQVcsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtTQUM3RDtRQUVELElBQUksUUFBUSxDQUFDLFFBQVEsS0FBSyxhQUFhLElBQUksUUFBUSxDQUFDLE1BQU0sQ0FBQyxlQUFlLENBQUMsRUFBRTtZQUMzRSxNQUFNLGdCQUFRLE1BQU0sQ0FBQyxlQUFlLENBQUUsQ0FBQTtTQUN2QztRQUVELElBQUksQ0FBQyxHQUFHLEdBQUcsTUFBTSxDQUFDLE1BQU0sZ0NBQ25CLFFBQVEsR0FDUixTQUFTLEdBQ1QsTUFBTSxFQUNULENBQUE7SUFDSixDQUFDO0lBSUQsd0JBQUcsR0FBSCxVQUFJLEdBQVc7UUFDYixJQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFBO1FBQ3pELElBQUksQ0FBQyxPQUFPLEVBQUU7WUFDWixNQUFNLElBQUksS0FBSyxDQUFDLHlGQUFpQixHQUFHLG1GQUFlLENBQUMsQ0FBQTtTQUNyRDtRQUNELE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUN0QixDQUFDO0lBQ0gsaUJBQUM7QUFBRCxDQUFDLEFBOUJELElBOEJDIn0=